import React from 'react';

// MUI Components
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';

// Components
import SiteTable from '../partials/site-table';

const Dashboard = () => {

    return (
        <Container maxWidth="xl">
            <Box className='dashboard-container'>
                <SiteTable />
            </Box>
        </Container>
    )

}

export default Dashboard;